import * as React from 'react';
import {Text} from '@discordapp/design/components/Text/Text.web';

import Anchor from '@developers/uikit/Anchor';
import {getLocalizedLink} from '@developers/utils/LinkUtils';
import FourOhFour from './404';

import {LocalizedLinks, Links} from '@developers/Constants';
import {Messages} from '@developers/i18n';
import styles from './index.module.css';

export default function Error() {
  return (
    <div className={styles.pageWrapper}>
      <div>
        <FourOhFour />
        <Text variant="text-lg/normal" className={styles.header}>
          {Messages.ERROR_PAGE_ERROR_HEADER}
        </Text>
        <Text variant="text-md/normal">{Messages.ERROR_PAGE_ERROR_DESCRIPTION}</Text>
        <div className={styles.linkText}>
          <Anchor href={Links.API_DOCS}>{Messages.ERROR_PAGE_DOCUMENTATION_LINK}</Anchor>
          <Anchor href={Links.STATUS}>{Messages.ERROR_PAGE_STATUS_PAGE_LINK}</Anchor>
          <Anchor href={getLocalizedLink(LocalizedLinks.TWITTER)}>{Messages.SOCIAL_MEDIA_TWITTER_HANDLE}</Anchor>
          <Anchor href={Links.HELP_AND_SUPPORT}>{Messages.ERROR_PAGE_SUPPORT_LINK}</Anchor>
        </div>
      </div>
    </div>
  );
}
